import React from 'react';
import { TouchableHighlight, Text, View } from 'react-native';

import colors from 'app/src/styles/colors';

const PageButton = ({label, isNumber, style, ...rest}) => {
  const color = style.color;
  delete style.color;

  return (
    <TouchableHighlight style={style} {...rest}>
      <Text style={{color}}>{label}</Text>
    </TouchableHighlight>
  );
}

const Pagination = ({ page, numberOfPages, onPageChange, label, styles }) => {

  const pageProps = (forPage, isNumber) => {
    const isCurrent = 1 === numberOfPages || forPage === page;

    const buttonStyle = {
      paddingLeft: 8,
      paddingRight: 8,
      paddingTop: 4,
      paddingBottom: 4,
      color: colors.link,
      ...styles?.button,
    };

    const currentButtonStyle = {
      ...buttonStyle,
      color: colors.textMuted,
      ...styles?.currentButton,
    };

    const currentNumberButtonStyle = {
      ...buttonStyle,
      borderWidth: 1,
      borderColor: colors.focus,
      borderRadius: 4,
      backgroundColor: colors.backgroundAlt,
      ...styles?.currentNumberButton,
    };

    let style = buttonStyle;

    if (isCurrent) {
      if (isNumber) {
        style = currentNumberButtonStyle;
      } else {
        style = currentButtonStyle;
      }
    }

    return {
      style,
      disabled: isCurrent,
      onPress: () => onPageChange(forPage),
    }
  }

  const style = {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: 12,
    gap: 4,
    ...styles?.container,
  };

  const labelStyle = {
    marginRight: 24,
    color: colors.textLight,
    fontSize: 14,
    ...styles?.label,
  };

  const maxPage = numberOfPages - 1;

  const startPage = Math.min(Math.max(0, page - 2), maxPage - 4);
  let showPages = [0,1,2,3,4].map(i => i + startPage);
  showPages = showPages.filter(i => i <= maxPage && i >= 0);

  return (
    <View style={style}>
      {label && <Text style={labelStyle}>{label}</Text>}
      <PageButton label="First" {...pageProps(0)} />
      <PageButton label="Prev" {...pageProps(Math.max(0, page - 1))} />

      {showPages.map(i => (
        <PageButton key={i} label={i + 1} {...pageProps(i, true)} />
      ))}

      <PageButton label="Next" {...pageProps(Math.min(maxPage, page + 1))} />
      <PageButton label="Last" {...pageProps(maxPage)} />
    </View>
  );
};

export default Pagination;
